// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__cJCdG","label":"LanguagePicker_label__U+Xt4","icon":"LanguagePicker_icon__xc4dE"};